import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Pricing from './components/Pricing';
import Testimonials from './components/Testimonials';
import Footer from './components/Footer';
import siteConfig from './config/site.json';

const App: React.FC = () => {
  return (
    <div className="App">
      <Header />
      <Hero />
      <Features />
      <Pricing />
      <Testimonials />
      {/* Connect with Us button after Testimonials */}
      <div style={{ display: 'flex', justifyContent: 'center', margin: '2rem 0' }}>
        <a
          href={`https://wa.me/${siteConfig.site.contact.whatsapp.replace(/[^0-9]/g, '')}`}
          target="_blank"
          rel="noopener noreferrer"
          className="primary-button"
          style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem', fontSize: '1.25rem', padding: '1rem 2.5rem' }}
        >
          <i className="fab fa-whatsapp"></i>
          Connect with Us
        </a>
      </div>
      <Footer />
      {/* WhatsApp Floating Button */}
      <a
        href={`https://wa.me/${siteConfig.site.contact.whatsapp.replace(/[^0-9]/g, '')}`}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          position: 'fixed',
          bottom: '32px',
          right: '32px',
          zIndex: 2000,
          background: '#25D366',
          color: 'white',
          borderRadius: '50%',
          width: '60px',
          height: '60px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 4px 16px rgba(0,0,0,0.18)',
          fontSize: '2rem',
          textDecoration: 'none',
        }}
        aria-label="Chat on WhatsApp"
      >
        <i className="fab fa-whatsapp"></i>
      </a>
    </div>
  );
};

export default App;
